import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// IMPORT YOUR INTERNAL IMAGES
import banner1 from "../assets/homebanner/background.jpg";
import banner2 from "../assets/homebanner/background1.jpg";
import banner3 from "../assets/homebanner/background2.jpg";



export default function HomePage() {
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };
    return (
        <>
            {/* HOME SECTION */}
            <section id="home" className="homepage">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    loop={true}
                    className="hero-swiper"
                >
                    {/* SLIDE 1 */}
                    <SwiperSlide>
                        <div
                            className="hero-slide"
                            style={{ backgroundImage: `url(${banner1})` }}
                        >
                            <div className="overlay">
                                <div className="hero-content">
                                    <h1>HEALING THE ROOT, NOT JUST THE SYMPTOMS</h1>
                                    <p>
                                        Experience gentle and effective homeopathic care that restores balance
                                        naturally — safe, personalized, and holistic treatment for every individual.
                                    </p>
                                    <button className="hero-btn" onClick={() => scrollToSection("appointment")}>BOOK CONSULTATION</button>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>

                    {/* SLIDE 2 */}
                    <SwiperSlide>
                        <div
                            className="hero-slide"
                            style={{ backgroundImage: `url(${banner2})` }}
                        >
                            <div className="overlay">
                                <div className="hero-content">
                                    <h1>NATURAL HEALING WITH A PERSONAL TOUCH</h1>
                                    <p>
                                        We focus on understanding your complete health history and strengthening
                                        your immune system through safe, side-effect-free remedies.
                                    </p>
                                    <button className="hero-btn" onClick={() => scrollToSection("approach")}>OUR APPROACH</button>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>

                    {/* SLIDE 3 */}
                    <SwiperSlide>
                        <div
                            className="hero-slide"
                            style={{ backgroundImage: `url(${banner3})` }}
                        >
                            <div className="overlay">
                                <div className="hero-content">
                                    <h1>COMPASSIONATE CARE FOR EVERY STAGE OF LIFE</h1>
                                    <p>
                                        From chronic conditions to everyday health concerns, we provide safe and
                                        effective homeopathic solutions for children, adults, and the elderly.
                                    </p>
                                    <button className="hero-btn" onClick={() => scrollToSection("conditions")}>VIEW TREATMENTS</button>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>

                </Swiper>
            </section>


        </>
    );
}